import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const PUSH_NOTIFICATION_EVENT_NAMES = {
  GRANTED: 'user_granted_push_notification',
  DENIED: 'user_denied_push_notification',
} as const;

export const trackPushNotificationEnabled = () => {
  gspx.trackEvent({
    name: PUSH_NOTIFICATION_EVENT_NAMES.GRANTED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.ALERTS,
    capability: GPX_CAPABILITIES.PERMISSIONS,
    route: GPX_ROUTES.CALL_QUEUE,
  });
};

export const trackPushNotificationDenied = () => {
  gspx.trackEvent({
    name: PUSH_NOTIFICATION_EVENT_NAMES.DENIED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.ALERTS,
    capability: GPX_CAPABILITIES.PERMISSIONS,
    route: GPX_ROUTES.CALL_QUEUE,
  });
};
